<script>
    import { createEventDispatcher } from 'svelte'
    import { Row, Col, Button } from 'sveltestrap'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import FormAlerts from '../FormAlerts.svelte'
    import TeamInfo from './TeamInfo.svelte'
    import Icon from 'svelte-awesome'
    import { plus } from 'svelte-awesome/icons'
    import { currentSchool } from '@fno/service/api/schools.js'

    export let context
    export let saving
    export let schoolId

    const { tier } = $currentSchool
    const dispatch = createEventDispatcher()
    const addBlankTeam = () => {
        context.form.teams = [
            ...context.form.teams,
            {
                $create: true,
                id: context.form.teams.length,
                attributes: {
                    sport: '',
                    name: '',
                    arenaId: '',
                    sportIconImage: {
                        url: ''
                    },
                    groupId: ''
                },
                meta: {
                    schoolId,
                    state: 'published'
                }
            }
        ]
    }
</script>

<h1>Teams</h1>

<p>
    Create each of the teams or activity groups that you would like to represent in the app.
    If you are a school with multiple levels for a group, create a new team for each level.
    For example: Varsity Football, JV Football, & Freshman Football.
</p>

<h2>Add Your Teams</h2>

<p>To get started, select <em>Add Another Team +</em> to begin team creation.</p>

<p>
    NOTE: The <em>Stat-Supported Sport Type</em> is all of the sports applicable for live stats. This is primarily
    used at the college level and above. If your event does not match one of the sports types, select <em>Other Sport</em>
    in the dropdown. Selections made have no effect on the display of the team inside the app.
</p>

{#each context.form.teams as team, index (team.id)}
    <Row class="mb-3">
        <Col>
            <TeamInfo 
                bind:context 
                formKey="teams" 
                arenas={context.view.arenas} 
                teamGroups={context.view.teamGroups} 
                {index}
                {tier}
                on:change />
        </Col>
    </Row>
{/each}

<Row>
    <Col>
        <p>
            <Button on:click={addBlankTeam}>
                Add another team
                <Icon data={plus} />
            </Button>
        </p>
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons
    {context}
    {saving}
    on:save
    on:nextStepClicked={() => dispatch('nextStepClicked', { context, tier })}
    on:previousStepClicked
/>
